import axios from 'axios';
import { FEEDBACKURL } from '../index';

export const getFeedBackApi = (postData) => {
  return axios.post(FEEDBACKURL, JSON.stringify(postData));
};
